export default "__VITE_ASSET__8ad2dqJj__"